import { fulfilled, failed, pending } from "lib/promiseMiddlewareTypes";
import initialState from "store/initialState";
import { GET_TEMPLATES } from "actions/templates";

const loadingTemplates = (state = initialState.loadingTemplates, action: any) => {
  switch (action.type) {
    case pending(GET_TEMPLATES):
      return true;
    case fulfilled(GET_TEMPLATES):
    case failed(GET_TEMPLATES):
      return false;
    default:
      return state;
  }
};

export default loadingTemplates;
